module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-editor-container"
  }, [_c('tui-image-editor', {
    ref: "tuiImageEditor",
    attrs: {
      "include-ui": _vm.useDefaultUI,
      "options": _vm.options
    },
    on: {
      "addText": _vm.onAddText,
      "objectMoved": _vm.onObjectMoved
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3401c70c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ImageEditorContainer.vue
// module id = 825
// module chunks = 1 3